import Link from "next/link";
import { Text } from "./Text";

export function Button({ className = "", role = "learn", ...props }) {
  const styles = `inline-block py-3 px-9 bg-rbd-primary hover:bg-rbd-secondary active:bg-rbd-tertiary ease-in duration-150 rounded-full ${className}`;

  const roles = {
    contact: { text: "Contact Us", link: "/contact-us" },
    consultation: { text: "Request Consultation", link: "/contact-us" },
    learn: { text: "About Red Ball Drills", link: "/about" },
    home: { text: "Return to Homepage", link: "/" },
    "alt-learn": { text: "Get In Touch", link: "/contact-us" },
  };

  return (
    <Link href={roles[role].link} className={styles} {...props}>
      <Text size="button">{roles[role].text}</Text>
    </Link>
  );
}
